<template>
  <div class="input-field-wrapper">
    <div v-if="type === 'select'" class="select-wrap">
      <van-field
        :required="required"
        :label="label"
        :disabled="disabled"
        :input-align="align"
        :value="render ? render(inputValue) : inputValue"
        :placeholder="placeholder"
        @click="disabled ? null : showPicker = true"
      />
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="options.map(o => o.title)"
          @cancel="showPicker = false"
          @confirm="onConfirmSelect"
        />
      </van-popup>
    </div>
    <div v-if="type === 'date'" :class="[isNewAssembly ? '' : 'date-wrap', 'date']">
      <template v-if="isNewAssembly">
        <van-field :value="inputValue" :disabled="disabled" :readonly="readonly" :required="required" :label="label" :placeholder="placeholder" @click="readonly ? () => {} : calendarShow = true" :input-align="align" />
      </template>
      <template v-else>
        <van-cell :title="label" :value="inputValue" @click="calendarShow = true" />
        <!-- 默认max date 为半年 -->
      </template>
      <van-calendar
        v-model="calendarShow"
        color="rgb(69, 115, 222)"
        :default-date="getDefaultDate"
        :type="dateType"
        allow-same-day
        @confirm="onConfirmDate"
        :min-date="new Date(1980, 0, 1)"
        :max-date="new Date(2099, 0, 1)"
      />

    </div>
    <div v-if="type === 'switch'" class="switch-wrap">
      <div :class="['van-field__label', required ? 'van-cell--required' : ''].join(' ')">{{label}}</div>
      <van-switch class='switch' v-model="inputValue" active-color="#4573DE" inactive-color="#E9E9EB" @change="onInputChange($event)"/>
    </div>
    <!-- 限制大小 -->
    <div v-if="type === 'file' && fileSize" :class="['file-wrap', color ? 'file-color' : '']">
      <van-uploader :multiple="multiple" :max-count="maxCount" :accept="accept" v-model="fileList" :max-size="fileSize * 1024" :before-read="beforeRead" :after-read="afterRead" :before-delete="beforeDelete" @oversize="onOversize">
        <div class="upload-item-wrap">
          <span class="iconfont">{{'\ue61f'}}</span>
        </div>
      </van-uploader>
    </div>
    <!-- 不限制大小 -->
    <div v-else-if="type === 'file' && !fileSize" :class="['file-wrap', color ? 'file-color' : '']">
      <van-uploader :multiple="multiple" :max-count="maxCount" :accept="accept" v-model="fileList" :before-read="beforeRead" :after-read="afterRead" :before-delete="beforeDelete">
        <div class="upload-item-wrap">
          <span class="iconfont">{{'\ue61f'}}</span>
        </div>
      </van-uploader>
    </div>
    <!-- 限制大小 -->
    <div v-if="type === 'fileNoAuth' && fileSize" :class="['file-wrap', color ? 'file-color' : '']">
      <van-uploader :multiple="multiple" :max-count="maxCount" :accept="accept" v-model="fileList" :max-size="fileSize * 1024" :before-read="beforeRead" :after-read="afterRead" :before-delete="beforeDelete" @oversize="onOversize">
        <div class="upload-item-wrap">
          <span class="iconfont">{{'\ue61f'}}</span>
        </div>
      </van-uploader>
    </div>
    <!-- 不限制大小 -->
    <div v-else-if="type === 'fileNoAuth' && !fileSize" :class="['file-wrap', color ? 'file-color' : '']">
      <van-uploader :multiple="multiple" :max-count="maxCount" :accept="accept" v-model="fileList" :before-read="beforeRead" :after-read="afterRead" :before-delete="beforeDelete">
        <div class="upload-item-wrap">
          <span class="iconfont">{{'\ue61f'}}</span>
        </div>
      </van-uploader>
    </div>
    <div v-if="type === 'radio'" class="radio-group-wrap">
      <div :class="['van-field__label', required ? 'van-cell--required' : ''].join(' ')">{{label}}</div>
      <van-radio-group
        class='radio-group'
        v-model="inputValue"
        direction="horizontal"
        @change="onInputChange($event)"
      >
        <van-radio v-for="(option, index) in options" :key="index" :name="option.value" :disabled="!!option.disabled" @click="handleClick(option)">
          <template #icon="props">
            <div class="radio-item default" v-if="!props.checked && !option.disabled">{{option.title}}</div>
            <div class="radio-item selected" v-if="props.checked && !option.disabled">{{option.title}}</div>
            <div class="radio-item disabled" v-if="!!option.disabled">{{option.title}}</div>
          </template>
        </van-radio>
      </van-radio-group>
    </div>
    <div v-if="type === 'originalRadio'" :class="['original-radio', align === 'right' ? 'original-radio-right' : '']">
      <div :class="['van-field__label', required ? 'van-cell--required' : ''].join(' ')">{{label}}</div>
      <van-radio-group
        v-model="inputValue"
        direction="horizontal"
        @change="onInputChange($event)"
      >
        <van-radio icon-size="18" v-for="(option, index) in options" :key="index" :name="option.value" :disabled="!!option.disabled" @click="handleClick(option)">
          {{ option.title }}
        </van-radio>
      </van-radio-group>
    </div>
    <div v-if="type === 'textarea'" class="textarea-wrap">
      <van-field
        v-model="inputValue"
        :label="`${label}`"
        :placeholder="placeholder"
        @input="onInputChange($event)"
        @focus="onFocus($event)"
        @blur="onBlur"
        :formatter="formatInputValue"
        ref="input"
        :type="type"
        :readonly="readonly"
        :required="required"
        :maxlength="maxlength"
      />
    </div>
    <div v-if="type === 'dateForm'" class="date-wrap">
      <van-cell v-if="inputValue" :title="label" :value="inputValue || readonly ? inputValue : placeholder ? placeholder : '请选择'" @click="readonly ? null : calendarShow = true" />
      <van-cell value-class="date-form" v-else :title="label" :value="readonly ? '' : placeholder ? placeholder : '请选择' " @click="readonly ? null : calendarShow = true" />
      <!-- 默认max date 为半年 -->
      <van-calendar v-model="calendarShow" :min-date="new Date(1980, 0, 1)" @confirm="onConfirmDate" placeholder="123123213" />
    </div>
    <div v-if="type === 'info'" class="info-wrap">
      <van-field
        :value="render ? render(inputValue) : inputValue"
        :label="`${label}`"
        @focus="onFocus($event)"
        :readonly="true"
      />
    </div>
    <div v-if="type === 'select-search'">
      <van-search v-model="value" placeholder="请输入搜索关键词" />
    </div>
    <!-- 连级选择 -->
    <div v-if="type === 'cascader'">
      <van-field :value="inputValue" :required="required" :readonly="readonly" :label="label" :placeholder="placeholder" @click="readonly ? () => {} : popShow = true" :input-align="align" />
    </div>
    <van-field
      v-if="type !== 'radio' && type !== 'select' && type !== 'select-search' && type !== 'originalRadio' && type !== 'file' && type !== 'switch' && type !== 'date' && type !== 'textarea' && type !== 'select' && type !== 'dateForm' && type !== 'info' && type !== 'cascader'"
      v-model="inputValue"
      :label="`${label}`"
      :placeholder="placeholder"
      @input="onInputChange($event)"
      @focus="onFocus($event)"
      @blur="onBlur"
      :formatter="formatInputValue"
      ref="input"
      :disabled="disabled"
      :type="type"
      label-width="100"
      :input-align="align"
      :readonly="readonly"
      :required="required"
      :maxlength="maxlength"
    >
      <slot slot="button" name="button"></slot>
    </van-field>
    <van-popup v-model="popShow" round position="bottom" :style="{ height: '50%' }" class="cascader">
      <van-cascader
        v-model="cascaderValue"
        active-color="rgb(69, 115, 222)"
        title="请选择所在地区"
        :options="options"
        @close="popShow = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>

<style>
  .img-icon {
    height: 20px;
  }
</style>

<script>
import {
  Field,
  RadioGroup,
  Uploader,
  Radio,
  Switch,
  Picker,
  Popup,
  Toast,
  Calendar,
  Cell,
  Checkbox,
  Cascader
} from 'vant'
import $ from 'jquery'
import moment from 'moment'

import {
  isObject,
  isArr
} from '@utils/basicUtil'
import UploadService from '@services/UploadService'

export default {
  name: 'inputField',
  props: {
    value: {
      type: [String, Boolean, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    noAuthParams: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    rangeField: {
      type: String,
      default: ''
    },
    dateType: {
      type: String,
      default: 'single'
    },
    align: {
      type: String,
      default: 'left'
    },
    required: {
      type: Boolean,
      default: false
    },
    isNewAssembly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    icon: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number
    },
    options: {
      type: Array
    },
    fileList: {
      type: Array
    },
    maxCount: {
      type: Number,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    fileSize: {
      type: Number,
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    color: {
      type: Boolean,
      default: false
    },
    render: {
      type: Function,
      default: null
    },
    substrFn: {
      type: Function,
      default: null
    },
    limitEmoji: {
      type: Boolean,
      default: false
    },
    emojiLimitToast: {
      type: String,
      default: '不支持输入表情符号'
    }
  },
  data () {
    return {
      popShow: false,
      inputValue: this.value,
      functionPoint: 'mobilecompany',
      calendarShow: false,
      showPicker: false,

      cascaderValue: ''
    }
  },
  watch: {
    value (newValue) {
      this.inputValue = newValue
    }
  },
  computed: {
    getRangDataValue () {
      let text = (this.inputValue || '')
      if (this.data[this.rangeField]) {
        text += ('~' + this.data[this.rangeField])
      }
      return text
    },
    getDefaultDate () {
      if (this.dateType === 'range') {
        let startTime = this.inputValue || new Date()
        let endTime = this.data[this.rangeField] || new Date()
        if (new Date(endTime) < new Date(startTime)) {
          const time = endTime
          endTime = startTime
          startTime = time
        }
        return [new Date(startTime), new Date(endTime)]
      }
      return this.inputValue ? new Date(this.inputValue) : new Date()
    },
    emojiLimitEnabled () {
      return this.limitEmoji || !!(this.item && this.item.limitEmoji)
    }
  },
  mounted () {
    console.log(this.options)
    console.log(this.inputValue)
    console.log(this.value)
    window.$ = $
  },
  methods: {
    onFinish ({ selectedOptions }) {
      this.popShow = false
      this.onInputChange(selectedOptions.map((option) => option.text).join(''))
    },
    handleClick: function (option) {
      if (option.onClick) {
        option.onClick()
      }
    },
    formatInputValue (value) {
      if (!this.emojiLimitEnabled) {
        return value
      }
      const nextValue = this.filterEmoji(value)
      if (nextValue !== value) {
        Toast(this.emojiLimitToast)
      }
      return nextValue
    },
    filterEmoji (value) {
      if (typeof value !== 'string') {
        return value
      }
      return value.replace(/(\uD83C[\uDDE6-\uDDFF]){2}|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27BF]\uFE0F?|\uFE0F|\u20E3|\u200D/g, '')
    },
    onInputChange: function ($event) {
      const nextValue = this.formatInputValue($event)
      if (this.substrFn) {
        const value = this.formatInputValue(this.substrFn(nextValue))
        this.inputValue = value
        this.$emit('oninputchange', value)
      } else {
        if (nextValue !== $event) {
          this.inputValue = nextValue
        }
        this.$emit('oninputchange', nextValue)
      }
    },
    onFocus: function (e) {
      this.$emit('onFocus', e)
      const inputHeight = e.currentTarget.offsetParent.offsetParent.offsetParent.offsetHeight
      const currentPositionY = this.getTop(e.currentTarget)
      setTimeout(() => {
        const bodyClientHeight = document.body.clientHeight
        const res = currentPositionY - bodyClientHeight + inputHeight + 50
        try {
          if (res > 0) {
            this.$emit('onscroll', res)
          }
        } catch (e) {
        }
      }, 500)
    },
    getTop: function (e) {
      var offset = e.offsetTop
      if (e.offsetParent != null) offset += this.getTop(e.offsetParent)
      return offset
    },
    onBlur () {
      this.$emit('onBlur')
    },
    onOversize () {
      Toast('文件超出最大文件限制！')
    },
    beforeRead (file) {
      console.log('上传前')
      if (this.accept === 'image/*') {
        if (isObject(file)) {
          if (
            file.type === 'image/jpeg' ||
            file.type === 'image/png'
          ) {
            return true
          } else {
            Toast('请上传 jpg/png/jpeg 格式图片')
            return false
          }
        } else if (isArr(file)) {
          if (file.every(item => item.type === 'image/jpeg' || item.type === 'image/png')) {
            return true
          } else {
            Toast('请上传 jpg/png/jpeg 格式图片')
            return false
          }
        }
      } else {
        return true
      }
    },
    async afterRead (oldFile) {
      let file = oldFile
      if (!Array.isArray(file)) {
        file = [file]
      }
      const allRes = await Promise.all(
        file.map(fileItem => {
          let newFile = fileItem
          newFile.status = 'uploading'
          newFile.message = '上传中...'
          if (this.type === 'fileNoAuth') {
            return UploadService(newFile.file, this.functionPoint, false, true, this.noAuthParams)
          } else {
            return UploadService(newFile.file, this.functionPoint)
          }
        })
      )
      allRes.forEach(res => {
        if (res.code === '200') {
          this.$emit('finishUpload', res)
        } else {
          this.$emit('finishUpload', {
            success: false,
            ...res
          })
        }
        this.fileListInside = []
      })
    },
    beforeDelete (file) {
      this.$emit('beforeDelete', file)
    },
    onConfirmDate (date) {
      this.calendarShow = false
      if (Array.isArray(date)) {
        this.onInputChange([moment(date[0]).format('YYYY-MM-DD'), moment(date[1]).format('YYYY-MM-DD')])
      } else {
        this.onInputChange(moment(date).format('YYYY-MM-DD'))
      }
    },
    onConfirmSelect (option, index) {
      this.showPicker = false
      this.inputValue = this.options[index].title
      this.onInputChange(this.options[index].value)
    }
  },
  components: {
    [Field.name]: Field,
    [Cascader.name]: Cascader,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Uploader.name]: Uploader,
    [Calendar.name]: Calendar,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox

  }
}
</script>

<style lang="less" scoped src="./style.less"/>
